import { api, fetchJson } from '@/shared/api';
import { apiRoutes } from '@/shared/routes';
import { type PreparationStage, type VisaPreparation } from './types';
import type { WireRequest, WireResponse } from '@/shared/generated/wire';

export async function recordStage(stage: PreparationStage): Promise<VisaPreparation> {
  return api.patch<WireResponse<'/app/api/visa/preparation', 'patch', 200>>(apiRoutes.visaPreparation,
    { stage } satisfies WireRequest<'/app/api/visa/preparation', 'patch'>);
}

export async function requestConsulting(): Promise<void> {
  const response = await fetchJson(apiRoutes.visaConsultingRequest, { method: 'POST' });
  if (!response.ok) throw new Error(`Failed to request consulting: ${response.status}`);
}
